export enum PERMISSION {
  DASHBOARD_READ = "dashboard:read",
  TENANT_READ = "tenant:read",
  TENANT_UPDATE = "tenant:update",
  TENANT_CREATE = "tenant:create",
  TENANT_DELETE = "tenant:delete",
  TENANT_SETTINGS_UPDATE = "tenantSettings:update",
  DEVICE_READ = "device:read",
  DEVICE_IMPORT = "device:import",
  DEVICE_CREATE = "device:create",
  DEVICE_UPDATE = "device:update",
  DEVICE_DELETE = "device:delete",
  FIRMWARE_READ = "firmware:read",
  FIRMWARE_CREATE = "firmware:create",
  FIRMWARE_UPDATE = "firmware:update",
  FIRMWARE_DELETE = "firmware:delete",
  FAULT_WIKI_READ = "faultWiki:read",
  FAULT_REPORTING_READ = "faultReporting:read",
  FAULT_REPORTING_EXPORT = "faultReporting:export",
  FAULT_LIST_MAINT_READ = "faultListMaint:read",
  FAULT_LIST_MAINT_CREATE = "faultListMaint:create",
  FAULT_LIST_MAINT_UPDATE = "faultListMaint:update",
  FAULT_LIST_MAINT_DELETE = "faultListMaint:delete",
  FAULT_LIST_READ = "faultList:read",
  FAULT_LIST_CREATE = "faultList:create",
  FAULT_LIST_UPDATE = "faultList:update",
  FAULT_LIST_DELETE = "faultList:delete",
  ASSET_STATUS_DETAILS_READ = "assetStatusDetails:read",
  ASSET_MASTER_DATA_READ = "assetMasterData:read",
  ASSET_MASTER_DATA_CREATE = "assetMasterData:create",
  ASSET_MASTER_DATA_UPDATE = "assetMasterData:update",
  ASSET_MASTER_DATA_DELETE = "assetMasterData:delete",
  STATISTICS_READ = "statistics:read",
  CORE_READ = "core:read",
  CORE_DELETE = "core:delete",
  ENERGY_TOOL_READ = "energyTool:read",
  REPAIR_REQUEST_READ = "repairRequest:read",
  REPAIR_REQUEST_CREATE = "repairRequest:create",
  REPAIR_REQUEST_UPDATE = "repairRequest:update",
  REPAIR_REQUEST_DELETE = "repairRequest:delete",
  INT_SERVICE_CONTRACT_READ = "intServiceContract:read",
  INT_SERVICE_CONTRACT_CREATE = "intServiceContract:create",
  INT_SERVICE_CONTRACT_UPDATE = "intServiceContract:update",
  INT_SERVICE_CONTRACT_DELETE = "intServiceContract:delete",
  EXT_SERVICE_CONTRACT_READ = "extServiceContract:read",
  EXT_SERVICE_CONTRACT_CREATE = "extServiceContract:create",
  EXT_SERVICE_CONTRACT_UPDATE = "extServiceContract:update",
  EXT_SERVICE_CONTRACT_DELETE = "extServiceContract:delete",
  CHANGELOG_READ = "changelog:read",
  BUTLER_MAINT_READ = "butlerMaint:read",
  BUTLER_MAINT_CREATE = "butlerMaint:create",
  BUTLER_MAINT_UPDATE = "butlerMaint:update",
  BUTLER_MAINT_DELETE = "butlerMaint:delete",
  MEDIA_READ = "media:read",
  MEDIA_CREATE = "media:create",
  MEDIA_UPDATE = "media:update",
  MEDIA_DELETE = "media:delete",
  ASSET_DYNAMIC_DATA_UPDATE = "assetDynamicData:update",
  ASSET_DYNAMIC_DATA_CREATE = "assetDynamicData:create",
  ASSET_DYNAMIC_DATA_READ = "assetDynamicData:read",
  ASSET_DYNAMIC_DATA_DELETE = "assetDynamicData:delete",
  ASSET_COMPONENT_READ = "assetComponent:read",
  ASSET_COMPONENT_CREATE = "assetComponent:create",
  ASSET_COMPONENT_UPDATE = "assetComponent:update",
  ASSET_COMPONENT_DELETE = "assetComponent:delete",
  USER_READ = "user:read",
  USER_CREATE = "user:create",
  USER_UPDATE = "user:update",
  USER_DELETE = "user:delete",
  NOTIFICATION_READ = "notification:read",
  NOTIFICATION_UPDATE = "notification:update",
  NOTIFICATION_FAULT_REPORTING = "notification:faultReporting",
  NOTIFICATION_INT_SERVICE_CONTRACT = "notification:intServiceContract",
  NOTIFICATION_EXT_SERVICE_CONTRACT = "notification:extServiceContract",
  NOTIFICATION_PREDICTIVE_SERVICE = "notification:predictiveService",
  NOTIFICATION_ENERGY_LOSS = "notification:energyLoss",
  NOTIFICATION_REPAIR_REQUEST = "notification:repairRequest",
  TIMESERIES_READ = "timeseries:read",
  ASSET_HIERARCHY_READ = "assetHierarchy:read",
  CORE_CREATE = "core:create",
  ROLE_READ = "role:read",
  ROLE_CREATE = "role:create",
  ROLE_UPDATE = "role:update",
  MAP_READ = "map:read",
  CUSTOMER_OVERVIEW_READ = "customer-overview:read",
  INSPECTION_REPORT_CREATE = "inspectionReport:create",
  INSPECTION_REPORT_READ = "inspectionReport:read",
  INSPECTION_REPORT_UPDATE = "inspectionReport:update",
  INSPECTION_REPORT_DELETE = "inspectionReport:delete",
  SERVICE_FORM_CREATE = "serviceForm:create",
  SERVICE_FORM_READ = "serviceForm:read",
  SERVICE_FORM_UPDATE = "serviceForm:update",
  SERVICE_FORM_DELETE = "serviceForm:delete",
  SYSTEM_ALERT_READ = "systemAlert:read",
  SYSTEM_ALERT_CREATE = "systemAlert:create",
  SYSTEM_ALERT_UPDATE = "systemAlert:update",
  SYSTEM_ALERT_DELETE = "systemAlert:delete",
  THIEF_PROTECTION_CONFIG_UPDATE = "thiefProtectionConfig:update",
  THIEF_PROTECTION_CONFIG_READ = "thiefProtectionConfig:read",
  THIEF_PROTECTION_CONFIG_DELETE = "thiefProtectionConfig:delete",
  THIEF_PROTECTION_CONFIG_CREATE = "thiefProtectionConfig:create",
  THIEF_PROTECTION_STATUS_UPDATE = "thiefProtectionStatus:update",
  THIEF_PROTECTION_STATUS_READ = "thiefProtectionStatus:read",
  GATE_SECURITY_SETTINGS_CREATE = "gateSecuritySettings:create",
  GATE_SECURITY_SETTINGS_READ = "gateSecuritySettings:read",
  GATE_SECURITY_SETTINGS_UPDATE = "gateSecuritySettings:update",
  GATE_SECURITY_SETTINGS_DELETE = "gateSecuritySettings:delete",
  IGNORED_FAULT_LIST_CREATE = "ignoredFaultList:create",
  IGNORED_FAULT_LIST_READ = "ignoredFaultList:read",
  IGNORED_FAULT_LIST_UPDATE = "ignoredFaultList:update",
  IGNORED_FAULT_LIST_DELETE = "ignoredFaultList:delete",
  LANGUAGE_CREATE = "language:create",
  LANGUAGE_READ = "language:read",
  LANGUAGE_UPDATE = "language:update",
  LANGUAGE_DELETE = "language:delete",
  ENERGY_TOOL_CREATE = "energyTool:create",
  ENERGY_TOOL_DELETE = "energyTool:delete",
  ENERGY_TOOL_EXPORT = "energyTool:export",
  BUTLER_CONFIG_CREATE = "butlerConfig:create",
  BUTLER_CONFIG_READ = "butlerConfig:read",
  BUTLER_CONFIG_UPDATE = "butlerConfig:update",
  BUTLER_CONFIG_DELETE = "butlerConfig:delete",
  HARDWARE_CONFIG_READ = "hardwareConfig:read",
  HARDWARE_CONFIG_UPDATE = "hardwareConfig:update",
}
